module.exports = __webpack_public_path__ + "img/_DSC7772-min.cd789cfe.jpg";